/**
 * @file keywordConstants.js
 * @description Constants for the Keyword module within the Dashboard section.
 *              Includes UI label strings, tab configurations, error messages, and a date formatting utility.
 *
 * @module keywordConstants
 *
 * @exports KEYWORD_STRINGS   - UI label strings for the keyword search panel.
 * @exports KEYWORD_TABS      - Tab label strings for the keyword panel.
 * @exports KEYWORD_ERRORS    - Error message strings for keyword data fetching.
 * @exports formatDateTime    - Utility function to format date/time values.
 */
export const KEYWORD_STRINGS = {
	SEARCH_KEYWORD: "Search Keyword(s)",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    NO_RESULTS: "No Record Found",
};

export const KEYWORD_TABS = {
    TEXTS: "Texts",
	EMAILS: "Emails",
};

export const KEYWORD_ERRORS = {
    FETCH_KEYWORD_ERROR: "Error fetching keyword data.",
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};
